import React, { Component } from "react";
import style from "./UserRoleCreation.module.css";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import history from "../../../utils/history";
import api from "../../../utils/Api";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import { fetchDropdownList } from "../../../redux";
import { connect } from "react-redux";

export class UserRoleCreation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      role_name: "",
      role_status: "",
      permissionData: [],
      loadingState: true,
      isEditMode: false,
      isPageTitle: "Create User Role",
      error: "",
      sucessMessage: "",
      errorMessage: "",
    };
    this.handleChange = this.handleChange.bind(this);
    // this.handleSubmit = this.handleSubmit.bind(this);
    this.backHandleClick = this.backHandleClick.bind(this);
    this.handleBlurChange = this.handleBlurChange.bind(this);
  }

  componentDidMount() {
    let role_id = "";

    if (this.props.match.params.id) {
      this.setState({
        isEditMode: true,
        isPageTitle: "Update User Role",
      });
      role_id = this.props.match.params.id;
    }
    this.setState({
      loadingState: true,
    });

    // Getting  feature permissions data from api
    this.getPermissions(role_id);
  }

  getPermissions(role_id) {
    const token =
      localStorage.getItem("USER_INFO") &&
      JSON.parse(localStorage.getItem("USER_INFO")).token;
    const headers = {
      Authorization: "Bearer " + token,
    };
    api
      .get("user/role/detail/fetch?role_id=" + role_id, {
        headers: headers,
      })
      .then((response) => {
        this.setState({
          permissionData: response.data.data.permissionList,
          loadingState: false,
          role_name: response.data.data.roleDetail.role_name,
          role_status: response.data.data.roleDetail.role_status,
        });
      })
      .catch((error) => {
        this.setState({
          loadingState: false,
        });
        if (error.response) {
          console.log("Error", error);
        }
      });
  }

  // Handle back button
  backHandleClick() {
    history.push("/userrolelist");
  }

  handleChange(key) {
    return function (e) {
      var state = {};
      state[key] = e.target.value;
      this.setState(state);
    }.bind(this);
  }

  handleCheckClick = (i) => {
    this.setState((state, props) => {
      state.permissionData[i].enable = !state.permissionData[i].enable;
      state.permissionData[i].enable =
        state.permissionData[i].enable === true ? 1 : 0;
      return {
        permissionData: [...state.permissionData],
      };
    });
  };

  handleBlurChange() {
    if (this.state.role_name === undefined || this.state.role_name === "") {
      this.setState({
        error: "Role name and status is mandatory",
      });
    } else {
      this.setState({
        error: "",
      });
    }
  }

  // Form submission
  handleSubmit = async (event) => {
        this.setState({
          errorMessage:""
        });
    event.preventDefault();
    const payload = {
      roleDetail: {
        role_name: this.state.role_name,
        role_status: this.state.role_status,
      },
      permissionList: this.state.permissionData,
    };

    if (this.state.isEditMode) {
      payload.roleDetail.role_id = this.props.match.params.id;
    }

    // Post user creation data
    if (
      this.state.role_name !== undefined &&
      this.state.role_status !== undefined
    ) {
      try {
        const headers = {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        };
        const response = await api.post("user/role/save", payload, {
          headers: headers,
        });
        this.props.fetchDropdownList();
        if (response.status === 200 && !this.state.isEditMode) {
          this.setState({
            sucessMessage: "Role saved successfully! Please wait while redirecting...",
          });
          setTimeout(() => {
            this.setState({ sucessMessage: "" });
            history.push("/userrolelist");
          }, 2000);
        } else if (this.state.isEditMode) {
          this.setState({
            sucessMessage: "Role updated successfully! Please wait while redirecting...",
          });
          setTimeout(() => {
            this.setState({ sucessMessage: "" });
            history.push("/userrolelist");
          }, 2000);
        }
      } catch (error) {
        this.setState({
          errorMessage: error.response.data
            ? error.response.data.message
            : "Error in role deletion",
        });
        // setTimeout(() => {
        //   this.setState({ errorMessage: "" });
        // }, 2000);
      }
    } else {
      this.setState({
        error: "Role name and status is mandatory",
      });
    }
  };

  render() {
    let { permissionData } = this.state;
    return (
      <div className={style.UserRoleCreationWrapper}>
        <form onSubmit={this.handleSubmit} ref="createRole">
          <div className="row">
            <div className="col-md-6 col-lg-4 ">
              <h3>{this.state.isPageTitle}</h3>
            </div>
            {/* <div className="col-md-4 col-lg-4">
              <p className={`statusSucesssMessage  ${style.alignText}`}>
                {this.state.sucessMessage}
              </p>
              <p className={`statusErrorMessage  ${style.alignText}`}>
                {this.state.errorMessage}
              </p>
            </div> */}
            {/* <div className={`col-md-6 col-lg-4 ${style.btnWrapper}`}>
              <Button type="submit" color="primary" className="mr-2">
                Save
              </Button>
              <Button color="primary" onClick={this.backHandleClick}>
                Cancel
              </Button>
            </div> */}
          </div>
          <div className="row">
            <div class="col-md-12 intro-text">
              <p>
                This is the list of user roles available on the system. When the
                new user is created, it is assigned to the user role. The table
                shows no. of users associated per user role. Add Role button on
                top will allow to create a new user role and it will be listed
                on the table below. Please note, the table has delete operation
                only for the newly created roles. You can not delete the system
                roles. While deleting the role, you need to move the users to
                other role as requested in the delete popup. In that case, the
                user will have permissions as per the new role assigned.
              </p>
            </div>
          </div>

          <div className={`row ${style.roleTopWrapper}`}>
            <div className="col-md-6">
              <div className="form-group row">
                <label
                  htmlFor="roleName"
                  className={`col-md-2.5 col-form-label ${style.roleLabel}`}
                >
                  Role Name{" "}
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                </label>
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    id="roleName"
                    placeholder="Role Name"
                    value={this.state.role_name}
                    onChange={this.handleChange("role_name")}
                    onBlur={this.handleBlurChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <span className={style.statusLabel}>
                Status{" "}
                <span className="mandatory">
                  <small>*</small>
                </span>
              </span>
              <div>
                <div className="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    id="status1"
                    name="role_status"
                    className="custom-control-input"
                    value="Active"
                    checked={this.state.role_status === "Active"}
                    onChange={this.handleChange("role_status")}
                  />
                  <label className="custom-control-label" htmlFor="status1">
                    Active
                  </label>
                </div>
                <div className="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    id="status2"
                    name="role_status"
                    className="custom-control-input"
                    value="Inactive"
                    checked={this.state.role_status === "Inactive"}
                    onChange={this.handleChange("role_status")}
                  />
                  <label className="custom-control-label" htmlFor="status2">
                    Inactive
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <p className="error">{this.state.error}</p>
            </div>
          </div>
          <div className={`row ${style.roleStatusTableWrapper}`}>
            <div className="col-md-12">
              <h4 className={style.featureHeading}>Feature Permissions:</h4>
              <div className={style.tableHeightWrapper}>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Feature Name:</th>
                      <th>Enable</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.loadingState ? (
                      <tr>
                        <td colspan="2" className="text-center">
                          <img src={ttmLoader} alt="loader" className={style.loading} />
                        </td>
                      </tr>
                    ) : (
                      <React.Fragment>
                        {permissionData.map((element, index) => {
                          return (
                            <tr key={index}>
                              <td>{element.permission_name}</td>
                              <td>
                                <div className="custom-control custom-checkbox ">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id={element.permission_name}
                                    name={element.permission_name}
                                    checked={element.enable}
                                    onChange={this.handleCheckClick.bind(
                                      this,
                                      index
                                    )}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor={element.permission_name}
                                  ></label>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </React.Fragment>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <p className={`statusSucesssMessage  ${style.alignText}`}>
                {this.state.sucessMessage}
              </p>
              <p className={`statusErrorMessage  ${style.alignText}`}>
                {this.state.errorMessage}
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12 d-flex justify-content-between flex-column-reverse flex-md-row align-items-center">
              <Button
                type="button"
                className="form-primary-btn mb-3"
                onClick={this.backHandleClick}
              >
                Cancel
              </Button>
              <Button type="submit" className="form-primary-btn   mb-3">
                Save
              </Button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

// export default LoadDropdwon;
const mapStateToProps = (state) => {
  return {
    dropdownListData: state.dropdownList,
    permissionData: state.permissionData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDropdownList: () => dispatch(fetchDropdownList()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserRoleCreation);